exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-result-list .spacer{margin:0;padding:0;height:0;width:100%}.search-result-list .panel,.search-result-list .panel-body{margin-bottom:0!important}.panel-body.search-error-message{display:none;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/combined/SearchResultListView.css
// module id = 2001
// module chunks = 0